<template>
  <el-select
    style="width: 100%"
    :value="value"
    :placeholder="placeholder"
    @input="change($event)"
    :clearable="clearable"
    :disabled="disabled"
  >
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.name"
      :value="item.value"
    >
      <span>{{ item.name }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DictSelect',
  props: {
    value: {
      required: true,
    },
    type: {
      required: true,
      type: String,
    },
    placeholder: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['dictMap']),
    list() {
      return this.dictMap[this.type] || [];
    },
  },
  methods: {
    change(val) {
      this.$emit('input', val);
    },
  },
};
</script>
